import { render, staticRenderFns } from "./VotePage.vue?vue&type=template&id=8bbb3eea&scoped=true&"
import script from "./VotePage.vue?vue&type=script&lang=js&"
export * from "./VotePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbb3eea",
  null
  
)

export default component.exports